import { DOCUMENT_EDITING, FETCH_DOCUMENT } from '../actions/DocumentActions';

// INITIALIZE STATE
const initialState = {
    document: null,
    fetching: false,
    fetched: false,
    failed: false,
    isEditing: false,
};

// REDUCER
export const DocumentReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_DOCUMENT}_PENDING`:
            return {
                ...state,
                fetching: true,
                fetched: false,
                failed: false,
            };
        case `${FETCH_DOCUMENT}_FULFILLED`:
            return {
                ...state,
                document: action.payload,
                fetching: false,
                fetched: true,
                failed: false,
            };
        case `${FETCH_DOCUMENT}_REJECTED`:
            return {
                ...state,
                fetching: false,
                fetched: false,
                failed: true,
            };
        case DOCUMENT_EDITING:
            return {
                ...state,
                fetched: true,
                fetching: false,
                failed: false,
                isEditing: action.payload,
            };
        default:
            return state;
    }
};
